<template>
    <div class="modal fade" id="rankingCriteriaSelectorModal" role="dialog" aria-labelledby="rankingCriteriaSelectorModalLabel" backdrop="static" data-backdrop="static" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <!--<p>EventFormIds: {{eventFormIds}}</p>-->
                <div class="modal-header">
                    <h5 class="modal-title" id="rankingCriteriaSelectorModalLabel">{{ $t("rankingCriteria.title") + ' / ' + $t("editor.dropdown.register") }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" v-if="show ">
                    <!--{{selectedIds}}-->
                    <button type="button" class="btn btn-primary btn"
                            v-if="claims.rankingCriteria.create"
                            @click="createBtnClick">
                        {{$t('buttons.create.btnText')}}
                    </button>

                    <div v-cloak>
                        <div class="input-group col-sm-3 float-right">
                            <div class="input-group-addon fa fa-search" style="display:table-cell"></div>
                            <input class="form-control fa fa-search" name="query" v-model="searchQuery">
                        </div>
                    </div>
                    <custom-grid :data="items"
                                 :columns="gridColumns"
                                 :filter-key="searchQuery"
                                 :captions="gridCaptions"
                                 :gridName="'RankingCriteriaSelectorGrid'"
                                 :btns="gridBtns">
                    </custom-grid>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary mr-1" @click="onSelect">{{ $t("buttons.add.btnText") }}</button>
                    <button class="btn btn-secondary" @click="hide">{{$t("buttons.cancel")}}</button>
                </div>
            </div>
        </div>

        <RankingCriteriaCreateModal :show="showCreate" :showCloseBtn="false" @onClose="onCreateClose" @onSave="onCreate"></RankingCriteriaCreateModal>
        <RankingCriteriaEditModal v-model="model" :show="showEdit" :showCloseBtn="false" @onClose="onEditClose" @onSave="onEdit"></RankingCriteriaEditModal>
        <RankingCriteriaDetailsModal v-model="model" :show="showDetails" :showCloseBtn="false" @onClose="onDetailsClose"></RankingCriteriaDetailsModal>
    </div>
</template>

<script>
    import service from "../../services/rankingCriteria.service";
    import CustomGrid from "../../components/grid/CustomGrid";
    import RankingCriteriaDetailsModal from './details.modal'
    import RankingCriteriaEditModal from './edit.modal'
    import RankingCriteriaCreateModal from './create.modal'

    import { mapGetters } from 'vuex';

    export default {
        components: {
            CustomGrid,
            RankingCriteriaDetailsModal,
            RankingCriteriaEditModal,
            RankingCriteriaCreateModal
        },
        props: {
            show: {
                type: Boolean,
                required: false
            },
            select: {
                type: Function,
                required: false,
                default: null
            },
            initialValues: {
                type: Object,
                required: false
            },
            eventFormIds: [String, Number]
        },
        data() {
            return {
                items: [],
                searchQuery: '',
                gridCaptions: {
                    id: 'rankingCriteria.gridHeaders.id',
                    name: 'rankingCriteria.gridHeaders.name',
                    nameEn: 'rankingCriteria.gridHeaders.name',
                    other1: 'rankingCriteria.gridHeaders.other1',
                    other2: 'rankingCriteria.gridHeaders.other2',
                },
                loading: false,
                model: null,
                showEdit: false,
                showDetails: false,
                showCreate: false,
            };
        },
        methods: {
            onSelect() {
                if (this.select) {
                    this.select(this.selectedIds);
                    this.hide();
                }
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onClose(e) {
                const sender = $(e.target).attr('id');
                if (sender !== 'rankingCriteriaSelectorModal') {
                    e.preventDefault();
                    return;
                }

                this.$emit('update:show', false);
                this.$emit('onClose');
            },
            loadList() {
                this.loading = true;
                service
                    .getViewList(this.eventFormIds)
                    .then(response => {
                        if (response.data) {
                            this.items = response.data;
                        }
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('buttons.add.action'),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    }).then(() => { this.loading = false; });
            },
            createBtnClick() {
                if (!this.claims.rankingCriteria.create) {
                    return this.$router.push(`/unauthorized`);
                }

                this.showCreate = true;
            },
            editBtnClick(args) {
                if (!this.claims.rankingCriteria.update) {
                    return this.$router.push(`/unauthorized`);
                }

                this.showModal(args.id, false);
            },
            detailsBtnClick: function (args) {
                this.showModal(args.id, true);
            },
            showModal(id, details) {
                service
                    .getById(id)
                    .then(response => {
                        let model = response.data;
                        if (model) {
                            this.model = model;
                            if (details) {
                                this.showDetails = true;
                            } else {
                                this.showEdit = true;
                            }

                        } else {
                            this.model = null;
                            if (details) {
                                this.showDetails = false;
                            } else {
                                this.showEdit = false;
                            }
                        }
                    })
                    .catch(error => {
                        this.model = null;
                        if (details) {
                            this.showDetails = false;
                        } else {
                            this.showEdit = false;
                        }

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            onCreate(item) {
                this.showCreate = false;
                this.model = null;
                this.loadList();
            },
            onCreateClose() {
                this.showCreate = false;
                this.model = null;
            },
            onEdit(item) {
                this.showEdit = false;
                this.model = null;
                this.loadList();
            },
            onEditClose() {
                this.showEdit = false;
                this.model = null;
            },
            onDetailsClose() {
                this.showDetails = false;
                this.model = null;
            },
        },
        computed: {
            ...mapGetters(['isEnVersion', 'claims']),
            gridBtns() {
                return [
                    {
                        name: 'edit',
                        text: '',
                        tooltip: this.$t('buttons.editTemplate.btnText'),
                        class: 'btn btn-success',
                        icon: 'fas fa-edit',
                        show: this.claims.rankingCriteria.update,
                        clickHandler: this.editBtnClick
                    },
                    {
                        name: 'details',
                        text: '',
                        tooltip: this.$t('buttons.detailsTemplate.btnText'),
                        class: 'btn btn-secondary',
                        icon: 'fas fa-eye',
                        show: true,
                        clickHandler: this.detailsBtnClick
                    }
                ];
            },
            gridColumns() {
                return this.isEnVersion
                    ? ['checked', 'id', 'nameEn', 'other1', 'other2']
                    : ['checked', 'id', 'name', 'other1', 'other2'];
            },
            selectedIds() {
                if (!this.items || !Array.isArray(this.items)) {
                    return [];
                }

                return this.items.filter(x => x.checked === true).map(x => x.id);
            }
        },
        mounted() {
            //add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            //remove listeners
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                $(this.$el).modal(val ? 'show' : 'hide');
                if (val) {
                    this.loadList();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
